import { setElHeight, throttle } from './helpers'
import {initMenuAccessibility} from "./components/menu-accessibility";

// ========================================
// Detect keyboard vs mouse usage for focus styles
// ========================================
(function detectInputMethod() {
    // Remove class on any mouse action
    document.body.addEventListener('mousedown', () => {
        document.body.classList.remove('user-is-tabbing');
    });

    // Add class on Tab key press
    document.body.addEventListener('keydown', (e) => {
        if (e.key === 'Tab') {
            document.body.classList.add('user-is-tabbing');
        }
    });
})();

// ========================================
// Accessibility: Keyboard Navigation Enhancement
// ========================================
function enhanceAccessibility() {
    // Trap focus in modals
    const modals = document.querySelectorAll('[role="dialog"], .modal');
    modals.forEach(modal => {
        const focusableElements = modal.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );

        if (focusableElements.length > 0) {
            const firstFocusable = focusableElements[0];
            const lastFocusable = focusableElements[focusableElements.length - 1];

            modal.addEventListener('keydown', (e) => {
                if (e.key === 'Tab') {
                    if (e.shiftKey && document.activeElement === firstFocusable) {
                        e.preventDefault();
                        lastFocusable.focus();
                    } else if (!e.shiftKey && document.activeElement === lastFocusable) {
                        e.preventDefault();
                        firstFocusable.focus();
                    }
                }

                // Close modal on Escape
                if (e.key === 'Escape') {
                    modal.close?.();
                    modal.classList.remove('active', 'open');
                }
            });
        }
    });

    // Enhance dropdowns with keyboard support
    const dropdownButtons = document.querySelectorAll('[aria-haspopup="true"]');
    dropdownButtons.forEach(button => {
        button.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                button.click();
            }

            if (e.key === 'Escape') {
                const dropdown = button.nextElementSibling;
                if (dropdown && dropdown.classList.contains('active')) {
                    dropdown.classList.remove('active');
                    button.focus();
                }
            }
        });
    });

    // Add ARIA labels to interactive elements without labels
    document.querySelectorAll('button:not([aria-label])').forEach(button => {
        if (!button.textContent.trim() && !button.getAttribute('aria-label')) {
            console.warn('Button without accessible label:', button);
        }
    });
}

document.onreadystatechange = () => {

    if ( document.readyState === 'complete' ) {
        // Initialize accessibility enhancements
        enhanceAccessibility();

        // Initialize menu keyboard navigation
        initMenuAccessibility();

        const breakpoints = {
            xs: 575,
            sm: 767,
            md: 991,
            lg: 1199,
            xl: 1535
        }

        const viewport = window.innerWidth
        const container = document.getElementById('js-container')
        const hamburger = document.getElementById('js-hamburger')
        const mainNavigation = document.getElementById('js-main-navigation')

        // Desktop menu dropdown handlers (outside hamburger, for desktop)
        if (mainNavigation) {
            mainNavigation.querySelectorAll('.c-navigation__list-item button').forEach(btn => {
                // Click handler
                btn.addEventListener('click', (e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    let dropdown = btn.nextElementSibling

                    // Close other dropdowns
                    mainNavigation.querySelectorAll('.c-dropdown.active').forEach(otherDropdown => {
                        if (otherDropdown !== dropdown) {
                            otherDropdown.classList.remove('active');
                            const otherBtn = otherDropdown.previousElementSibling;
                            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
                        }
                    });

                    if (dropdown) {
                        const isOpen = dropdown.classList.toggle('active');
                        btn.setAttribute('aria-expanded', isOpen);
                    }
                })

                // Keyboard support
                btn.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        btn.click();
                    } else if (e.key === 'Escape') {
                        let dropdown = btn.nextElementSibling
                        if (dropdown && dropdown.classList.contains('active')) {
                            dropdown.classList.remove('active');
                            btn.setAttribute('aria-expanded', 'false');
                            btn.focus();
                        }
                    } else if (e.key === 'ArrowDown') {
                        e.preventDefault();
                        let dropdown = btn.nextElementSibling;
                        if (dropdown && !dropdown.classList.contains('active')) {
                            btn.click();
                        }
                        const firstLink = dropdown?.querySelector('a');
                        if (firstLink) {
                            setTimeout(() => firstLink.focus(), 50);
                        }
                    }
                });
            })

            // Close dropdowns on outside click
            document.addEventListener('click', (e) => {
                if (!mainNavigation.contains(e.target)) {
                    mainNavigation.querySelectorAll('.c-dropdown.active').forEach(dropdown => {
                        dropdown.classList.remove('active');
                        const btn = dropdown.previousElementSibling;
                        if (btn) btn.setAttribute('aria-expanded', 'false');
                    });
                }
            });
        }

        if ( hamburger ) {
            hamburger.addEventListener('click', () => {
                const isActive = hamburger.querySelector('.c-hamburger').classList.toggle('active');
                mainNavigation.classList.toggle('active')

                // Update ARIA attributes
                hamburger.setAttribute('aria-expanded', isActive);

                if ( viewport > breakpoints.xs ) {
                    mainNavigation.style.paddingLeft = container.offsetLeft + 'px'
                }
            })

            // Add keyboard support for hamburger
            hamburger.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    hamburger.click();
                }
            });
        }

        //
        // START LANGUAGES
        //----------------------------------------------------------------------//
        const languages = document.getElementById('js-languages')

        if ( languages ) {
            const langButton = languages.querySelector('.c-languages__active button, .c-languages__active');

            langButton.addEventListener('click', (e) => {
                e.preventDefault()
                let list = languages.querySelector('.c-languages__list')

                if ( list ) {
                    const isOpen = list.classList.toggle('active');
                    const toggleBtn = languages.querySelector('button');
                    if (toggleBtn) {
                        toggleBtn.setAttribute('aria-expanded', isOpen);
                    }
                }
            })

            // Keyboard support
            langButton.addEventListener('keydown', (e) => {
                let list = languages.querySelector('.c-languages__list');

                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    langButton.click();
                } else if (e.key === 'Escape') {
                    if (list && list.classList.contains('active')) {
                        list.classList.remove('active');
                        const toggleBtn = languages.querySelector('button');
                        if (toggleBtn) {
                            toggleBtn.setAttribute('aria-expanded', 'false');
                            toggleBtn.focus();
                        }
                    }
                } else if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    if (list && !list.classList.contains('active')) {
                        langButton.click();
                    }
                    const firstLink = list?.querySelector('a');
                    if (firstLink) firstLink.focus();
                }
            });

            // Close on outside click
            document.addEventListener('click', (e) => {
                if (!languages.contains(e.target)) {
                    let list = languages.querySelector('.c-languages__list');
                    if (list && list.classList.contains('active')) {
                        list.classList.remove('active');
                        const toggleBtn = languages.querySelector('button');
                        if (toggleBtn) {
                            toggleBtn.setAttribute('aria-expanded', 'false');
                        }
                    }
                }
            });
        }
        //
        // END LANGUAGES
        //----------------------------------------------------------------------//

        //
        // START PAGE HEADER SECTION
        //----------------------------------------------------------------------//
        const pageHeader = document.querySelector('.js-page-header')

        if ( pageHeader ) {
            let pageHeaderImg = pageHeader.querySelector('.c-page-header__image')

            if ( pageHeaderImg ) {
                // set css right by container offset from right window edge
                pageHeaderImg.style.right = ( window.innerWidth - container.offsetWidth ) / 2 + 'px'

                // on resize
                window.addEventListener('resize', () => {
                    pageHeaderImg.style.right = ( window.innerWidth - container.offsetWidth ) / 2 + 'px'
                })
            }
        }
        //
        // END PAGE HEADER SECTION
        //-----------------------------------------------------------------------//

        //
        // START OFFICES SECTION
        //----------------------------------------------------------------------//
        const officesSection = document.querySelectorAll('.js-offices')

        if ( officesSection ) {
            officesSection.forEach( officeSection => {

                let headingsLines = officeSection.querySelectorAll('h3 .line')
                let boxes = officeSection.querySelectorAll('.box')

                if ( headingsLines ) {

                    headingsLines.forEach( line => {
                        // set line width 100vw - parent width - container left offset
                        line.style.width = 'calc(100vw - ' + line.parentElement.offsetWidth + 'px - ' + container.offsetLeft + 'px)'
                    })
                }

                if ( boxes ) {

                    if (viewport > breakpoints.sm) {
                        setElHeight(boxes)
                    }

                    // on resize
                    window.addEventListener('resize', throttle(() => {
                        if (window.innerWidth > breakpoints.sm) {
                            setElHeight(boxes)
                        }
                    }, 100))
                }
            })
        }
        //
        // END OFFICES SECTION
        //----------------------------------------------------------------------//

        //
        // START JS TO RIGHT
        //----------------------------------------------------------------------//
        const elToRight = document.querySelectorAll('.js-to-right')

        if ( elToRight ) {
            elToRight.forEach( el => {
                // set marginRight by container offset from right window edge
                if ( viewport > breakpoints.lg ) {
                    el.style.marginRight = - ( window.innerWidth - container.offsetWidth ) / 2 - 15 + 'px'
                }

                // on resize
                window.addEventListener('resize', () => {
                   if ( this.innerWidth > breakpoints.lg ) {
                        el.style.marginRight = - ( window.innerWidth - container.offsetWidth ) / 2 - 15 + 'px'
                   }
                })
            })
        }
        //
        // END JS TO RIGHT
        //----------------------------------------------------------------------//

        //
        // START HANDLE MODALS
        //----------------------------------------------------------------------//
        const modalTriggers = document.querySelectorAll('.js-modal-trigger')

        if ( modalTriggers ) {
            modalTriggers.forEach( trigger => {
                trigger.addEventListener('click', e => {
                    e.preventDefault()
                    let modalName = trigger.getAttribute('data-modal-name')
                    let modalTitle = trigger.getAttribute('data-modal-title') ?? ''
                    if ( modalName ) {
                        showModal(modalName)
                        setModalTitle(modalTitle)
                    }
                })
            })
        }
        //
        // END HANDLE MODALS
        //----------------------------------------------------------------------//

        //
        // START POST SECTION
        //----------------------------------------------------------------------//
        const posts = document.querySelectorAll('.js-post')

        if ( posts.length ) {

            posts.forEach( post => {
                let linkButton = post.querySelector('button.link')
                let moreContent = post.querySelector('.more-content')
                let columnText = post.querySelector('.column .text')
                let image = post.querySelector('picture img')

                // if is safari
                if ( /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification)) ) {
                    // set image height by column height
                    if ( image ) {
                        image.style.maxHeight = columnText.offsetHeight + 'px'
                    }
                }


                if ( linkButton && moreContent ) {

                    linkButton.addEventListener('click', e => {
                        e.preventDefault()
                        moreContent.classList.toggle('active')
                    })
                }
            })
        }
        //
        // END POST SECTION
        //----------------------------------------------------------------------//

        //
        // START ICONS SECTION
        //----------------------------------------------------------------------//
        const iconSection = document.querySelectorAll('.js-icons')

        if ( iconSection ) {

            iconSection.forEach( section => {
                let icons = section.querySelectorAll('.icon')

                if ( icons ) {

                    icons.forEach( icon => {
                        icon.addEventListener('click', e => {
                            e.preventDefault()

                            // siblings remove class active
                            icons.forEach( el => {
                                el.classList.remove('active')
                            })

                            // add class active to clicked element
                            icon.classList.add('active')

                            let scrollTarget = icon.getAttribute('data-target')

                            if ( scrollTarget ) {
                                let target = document.getElementById(scrollTarget)

                                if ( target ) {
                                    // scroll to target
                                    window.scrollTo({
                                        top: target.offsetTop - 100,
                                        behavior: 'smooth'
                                    })
                                }
                            }
                        })
                    })
                }
            })
        }

        //
        // END ICONS SECTION
        //----------------------------------------------------------------------//

//
        // FORM STUFF
        //---------------------------------------------------------------------------------------//
        /*$('.js-form-gr').submit(function (event) {
            event.preventDefault()
            let $form = $(this)
            const datakey = $('#js-form-gr-key').attr('data-key')
            console.log(datakey)
            return
            grecaptcha.ready(function () {
                grecaptcha.execute(datakey, { action: 'send' }).then(function (token) {
                    $form.prepend('<input type="hidden" name="token" value="' + token + '">')
                    $form.unbind('submit').submit()
                })
            })
        })*/
        // if form exists
        if ( document.querySelector('.js-form-gr') ) {
            document.querySelector('.js-form-gr').addEventListener('submit', function (event) {
                event.preventDefault();

                var form = this;
                var dataKey = document.getElementById('js-form-gr-key').getAttribute('data-key');

                let vueFiles = window.uploadedFiles || [];
                let fileContainer = document.getElementById('file-hidden-inputs');

                if (fileContainer && vueFiles && vueFiles.length) {
                    fileContainer.innerHTML = '';
                    vueFiles.forEach(file => {
                        let input = document.createElement('input');
                        input.type = 'file';
                        input.name = 'file[]';
                        // Create a DataTransfer object to populate the input's files
                        let dataTransfer = new DataTransfer();
                        dataTransfer.items.add(file); // Add file to DataTransfer
                        input.files = dataTransfer.files; // Set input's files to DataTransfer files
                        fileContainer.appendChild(input); // Add it to the hidden container
                    });
                }

                form = this;

                grecaptcha.ready(function () {
                    grecaptcha.execute(dataKey, { action: 'send' }).then(function (token) {
                        var tokenInput = document.createElement('input');
                        tokenInput.type = 'hidden';
                        tokenInput.name = 'token';
                        tokenInput.value = token;

                        form.appendChild(tokenInput);
                        form.submit();
                    });
                });
            });
        }
        //
        // END FORM STUFF
        //---------------------------------------------------------------------------------------//


        let teamContactToggle = document.querySelectorAll('.js-toggle-contact-text');

        if (teamContactToggle) {
            teamContactToggle.forEach( el => {
                el.addEventListener('click', displayContactText);
            });
        }
        function displayContactText(event) {
            let a = event.target.nextElementSibling;
            if (a.style.display === 'inline-block') {
                a.style.display = 'none';
                event.target.classList.add('glowing');
            } else {
                a.style.display = 'inline-block';
                event.target.classList.remove('glowing');
            }
        }

        /*
         * START Accordion
         */

        const accordion = document.querySelectorAll('.js-accordion');

        // Function to get URL parameter by name
        function getUrlParameter(name) {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get(name);
        }

        // Function to open accordion by id
        function openAccordionById(id) {
            const targetAccordion = document.getElementById(id);
            if (targetAccordion) {
                const title = targetAccordion.querySelector('.c-accordion__title');
                const content = title.nextElementSibling;

                // Open the accordion
                title.classList.add('active');
                targetAccordion.classList.add('active');
                content.style.display = "block";

                // Scroll to the accordion
                const ta = document.getElementById(id);
                ta.scrollIntoView({ behavior: 'smooth' });
            }
        }

        // Attach click event listeners to each accordion title
        if (accordion.length) {
            const id = getUrlParameter('id');
            if (id) {
                openAccordionById(id);
            }

            accordion.forEach(acc => {
                const titles = acc.querySelectorAll('.c-accordion__title');

                titles.forEach(item => {
                    item.addEventListener('click', function () {
                        // Toggle the clicked item
                        this.classList.toggle('active');
                        const parentAccordionItem = item.closest('.c-accordion__item');
                        parentAccordionItem.classList.toggle('active');

                        const content = this.nextElementSibling;
                        if (content.style.display === "block") {
                            content.style.display = "none";
                        } else {
                            content.style.display = "block";
                        }

                        // Update URL with id of the parent accordion item
                        const id = parentAccordionItem.getAttribute('id');
                        if (id) {
                            const newUrl = `${window.location.pathname}?id=${id}`;
                            window.history.pushState(null, '', newUrl);
                        }

                        // Close other accordion items
                        titles.forEach(otherItem => {
                            if (otherItem !== item) {
                                const otherContent = otherItem.nextElementSibling;
                                const otherParentAccordionItem = otherItem.closest('.c-accordion__item');

                                otherItem.classList.remove('active');
                                if (otherParentAccordionItem) {
                                    otherParentAccordionItem.classList.remove('active');
                                }
                                otherContent.style.display = "none";
                            }
                        });

                        // Scroll to the accordion
                        //const ta = document.getElementById(id);
                        this.scrollIntoView({ behavior: 'smooth' });
                    });
                });
            });
        }
        /*
         * END Accordion
         */

    }
}
